import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import {
  MatSnackBar,
  MatSnackBarHorizontalPosition,
  MatSnackBarVerticalPosition,
} from '@angular/material/snack-bar';
import { ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { v4 } from 'uuid';
import { LoadingService } from '../../shared/loading.service';
import { ConfigurationsStudiesModalComponent } from '../../studies-clientes-screens/modals/configurations-studies-modal/configurations-studies-modal.component';
import { UsersApplicationsService } from '../users-applications.service';
import { environment } from './../../../environments/environment';
@Component({
  selector: 'app-select-client-study',
  templateUrl: './select-client-study.component.html',
  styleUrls: ['./select-client-study.component.scss'],
})
export class SelectClientStudyComponent implements OnInit {
  @Input() adminId: string;

  @Input() application: string;

  @Input() clientId: string;

  @Input() isPersonStudies: boolean = false;

  routeParam: string = '';

  studiesList: any[] = [];

  guiaStudiesList: any[] = [];

  filteredstudiesList: any[] = [];

  loading = true;
  pageSize = 5;
  currentPage = 1;
  userName: string;
  searchTerm: '';
  numberOfPages: number = 1;

  horizontalPosition: MatSnackBarHorizontalPosition = 'end';
  verticalPosition: MatSnackBarVerticalPosition = 'top';
  durationInSeconds = 2;

  constructor(
    public toster: ToastrService,
    private _snackBar: MatSnackBar,
    public usersApplicationsService: UsersApplicationsService,
    private loadingService: LoadingService,
    private dialog: MatDialog,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    
    //Pegar a URL
    const segment = this.route.snapshot.url[1]?.path;
    this.routeParam = segment || '';

    if (!this.clientId && this.adminId) {
      this.clientId = this.adminId;
    }
    // Pegar nome da aplicação
    const aplicationselector = this.loadingService.getLoadingState();
    
    this.removeCookies()
    
    this.usersApplicationsService
      .getEspecificUser(this.clientId)
      .subscribe((userlist: any) => {
        this.userName = `${userlist.firstName} ${userlist.lastName}`;
        document.cookie = `clientName=${this.userName}; path=/; domain=.techfinance.com.br`;
      });

    if (this.application === 'guia') {
      this.usersApplicationsService
        .getGuiaStudies(this.clientId, this.routeParam)
        .subscribe((response: any) => {
          this.loading = false;
          this.studiesList = response.data;
          this.numberOfPages = Math.ceil(
            this.studiesList.length / this.pageSize
          );
          this.filteredstudiesList = this.studiesList;
        });
    } else {
      this.usersApplicationsService
        .getSoftwareStudies(aplicationselector, this.clientId)
        .subscribe((studiesList: any) => {
          this.loading = false;
          this.studiesList = studiesList;
          this.numberOfPages = Math.ceil(
            this.studiesList.length / this.pageSize
          );

          this.filteredstudiesList = this.studiesList;
        });
    }
  }

  create() {
    this.openLink(v4());
  }

  openLink(id: string, studyId?: number) {
    const aplicationselector = this.loadingService.getLoadingState();
    this.usersApplicationsService
      .getAccessToken(this.clientId, aplicationselector, id)
      .subscribe(
        (response: any) => {
          this.openFolder(this.application, response.accessToken, studyId);
        },
        () => {
          alert('Tivemos um problema ao abrir a pasta deste usuário.');
        }
      );
  }

  openFolder(software: string, token: string, studyId?: number) {
  if (software === 'guia') {
    if (!studyId) {
      this.usersApplicationsService.createStudy(this.clientId, token, this.routeParam).subscribe(
        (res: any) => {
          if (res.success) {
            this.saveStudyId(res.data.id);
            location.href = 'https://guia.techfinance.com.br/home'; 
          } else {
            this.showError('Erro ao salvar os dados de sessão. Tente novamente.');
          }
        },
        (error) => {
          console.error('Erro ao criar estudo:', error);
          this.showError('Erro ao criar estudo. Tente novamente.');
        }
      );
    } else {
      this.saveStudyId(studyId);
      location.href = 'https://guia.techfinance.com.br/presentation';
    }
  } else {
    // Se o software não for 'guia', faz o redirecionamento baseado no token
    location.href = environment.clientRedirect
      .replace('techfinance', software + '.techfinance')
      .replace('.qa.', '.') +
      '/folder-token/callback/' + token;
  }
}

  openLinkcadastro(subdomain: string, route: string) {
    if (subdomain === 'login' && environment.isQa === true) {
      location.href = (
        'https://' +
        subdomain +
        '.' +
        environment.baseUrl +
        route
      ).replace('app', '');
      return;
    }
    location.href =
      environment.clientRedirect.replace('app', subdomain) + route;
  }

  get startIndex(): number {
    return (this.currentPage - 1) * this.pageSize;
  }

  get endIndex(): number {
    return this.currentPage * this.pageSize;
  }

  get totalPages(): number {
    return Math.ceil(this.studiesList.length / this.pageSize);
  }

  nextPage() {
    if (this.currentPage < this.totalPages) {
      this.currentPage++;
    }
  }

  previousPage() {
    if (this.currentPage > 1) {
      this.currentPage--;
    }
  }

  goToPage(page: number): void {
    this.currentPage = page;
  }

  getPages(): number[] {
    return Array.from({ length: this.numberOfPages }, (_, i) => i + 1);
  }

  searchUsers() {
    this.filteredstudiesList = this.studiesList.filter((studie) =>
      studie.name.toLowerCase().includes(this.searchTerm.toLowerCase())
    );
    this.currentPage = 1;
  }

  openApplicationModal(id: string, study: any) {
    const dialogRef = this.dialog.open(ConfigurationsStudiesModalComponent, {
      disableClose: true,
      data: {
        UserId: this.clientId,
        studieId: id,
        study,
      },
      panelClass: 'custom-dialog-container',
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result.deleted) {
        this.toster.success(`estudo "${study.name}" foi excluído`);
        this.filteredstudiesList = this.filteredstudiesList.filter(
          (item) => item._id !== result.studyId
        );
      }
      if (result.updated) {
        this.toster.success(`Suas edições foram salvas`);
        const studyIndex = this.filteredstudiesList.findIndex(
          (item) => item._id === result.study._id
        );
        if (studyIndex !== -1) {
          this.filteredstudiesList[studyIndex].name = result.study.name;
        }
      }
    });
  }

  saveStudyId(studyId: number | string){
    try {
      localStorage.setItem('studyId', String(studyId));
      document.cookie = `studyId=${studyId}; path=/; domain=.techfinance.com.br`;
    } catch (error) {
      console.error('Erro ao salvar studyId:', error);
      this.showError('Erro desconhecido ao salvar os dados de sessão. Tente novamente.');
    }
  }

  private showError(message: string) {
    this._snackBar.open(message, 'X', {
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
      duration: this.durationInSeconds * 3000,
      panelClass: ['error-toast'],
    });
  }

  private removeCookies() {
    console.log(this.application)
    if (this.application === 'guia') {
      document.cookie =
        'formsId=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=.techfinance.com.br';
      document.cookie =
        'studyId=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=.techfinance.com.br';
      document.cookie =
        'clientName=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=.techfinance.com.br';
        console.log("Cookies apagados")
    }
  }

}
